module.exports = __webpack_public_path__ + "static/img/BU01KB-2.3a8128b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/BU01KB-2.jpg
// module id = p/tf
// module chunks = 1